import { Routes } from '@angular/router';
import { authGuard, roleGuard } from '../../guards/auth.guard';
import { UserRoles } from '@shared/models/user-roles';

export const orderTemplatesRoutes: Routes = [
  {
    path: 'order-templates',
    title: 'Auftragsvorlagen Übersicht',
    loadComponent: () =>
      import('./order-templates-list/order-templates-list').then(
        m => m.OrderTemplatesListComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'order-templates/new',
    title: 'Neue Auftragsvorlage',
    loadComponent: () =>
      import('./order-templates-form/order-templates-form').then(
        m => m.OrderTemplatesFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
  {
    path: 'order-templates/:id/edit',
    title: 'Auftragsvorlage bearbeiten',
    loadComponent: () =>
      import('./order-templates-form/order-templates-form').then(
        m => m.OrderTemplatesFormComponent
      ),
    canActivate: [roleGuard],
    data: { roles: [UserRoles.ORDER_WRITE] },
  },
];
